<div class="pds-form-section">
  <ng-container *ngIf="title">
    <h3 class="pds-form-section__title">{{ title }}</h3>
  </ng-container>
  <ng-content></ng-content>
</div>
